import api from '../api/api';
import {
  LOGIN_REQUEST,
  REMOVE_AUTH_ERROR,
  GET_MY_PROFILE_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  SET_EMAIL_SENT_TO_FALSE,
  LOG_OUT,
  EDIT_PROFILE_REQUEST,
} from './actionTypes';

export const login = (email, password) => ({
  type: LOGIN_REQUEST,
  payload: {
    email,
    password,
  },
});

export const editProfile = (
  firstName,
  lastName,
  phoneNumber,
  address,
  birthday,
) => ({
  type: EDIT_PROFILE_REQUEST,
  payload: {firstName, lastName, phoneNumber, address, birthday},
});

export const getMyProfile = () => ({type: GET_MY_PROFILE_REQUEST});
export const forgotPassword = email => ({type: FORGOT_PASSWORD_REQUEST, email});

export const clearAuthError = () => ({type: REMOVE_AUTH_ERROR});
export const setEmailSentFalse = () => ({type: SET_EMAIL_SENT_TO_FALSE});

export const logout = () => {
  localStorage.removeItem('token');
  api.defaults.headers.common['Authorization'] = ``;
  window.location.reload(false);
  return {
    type: LOG_OUT,
  };
};
